import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../constants.mjs";
function share(text) {
  const command = {
    command: INTERFACE.SHARE,
    parameters: {
      text
    }
  };
  return exec(command);
}
export {
  share
};
